/* eslint-disable no-underscore-dangle */
import React, { Fragment, useEffect, useMemo, useState } from "react";
import { defaultProps } from "utils/General";
import * as R from "ramda";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { MODES } from "../../../constants";
import { getters, actions } from "SendEmailModal/model";
import Loading from "ui-kit/Loading";
import { IFrame } from "./BuildIframe";
import * as SEND_TO_OPTION_TYPES from "SendEmailModal/utils/send-to-option-types";
import {
  Div,
  OpenInNewIcon,
  ErrorIcon,
  CheckCircleIcon,
  SimpleTable,
  Radio,
  RefreshIcon,
  LoadingIcon,
  Dropdown,
  Text1
} from "components/Base";
import Checkbox from "material-ui/Checkbox";
import { getIsLightEvent } from "redux/modules/event/selectors";
import { getIsLightOrg } from "redux/modules/organization/selectors";
import {
  formattedContactsSelected,
  getCountOfEmailSenders,
  getUniquePreviewMetaId
} from "../../../selectors";
import { noop } from "utils/General";
import { formattedValidRecipients } from "./utils";

const decorate = R.compose(
  withRouter,
  connect(
    state => ({
      isLightEvent: getIsLightEvent(state),
      isLightOrg: getIsLightOrg(state),
      loading: getters.generatingPreviews(state),
      preview: getters.preview(state),
      multiplePreview: getters.multiplePreview(state),
      particularContactsSelected: getters.particularContactsSelected(state),
      contactsSelected: formattedContactsSelected(state),
      countOfEmailSenders: getCountOfEmailSenders(state),
      uniquePreviewMetaIds: getUniquePreviewMetaId(state)
    }),
    {
      getPreview: actions.getPreview,
      handleSelectParticularContact: actions.handleSelectParticularContact,
      setParticularContactsSelected: actions.setParticularContactsSelected,
      selectAll: actions.selectAllHandler
    }
  )
);

const makeRecipientsTable = (
  mode,
  selectedOptions,
  handleSelectParticularContact,
  particularContactsSelected,
  refreshing
) => {
  return SimpleTable({
    columnProps: [
      [5 / 12, "left"],
      [5 / 12, "left"],
      [2 / 12, "right"]
    ],
    headerCellComps:
      selectedOptions !== SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS
        ? ["Name", mode === MODES.SMS ? "Phone Number" : "Email", "Action"]
        : ["Name", mode === MODES.SMS ? "Phone Number" : "Email"],
    HeaderCellStyler: defaultProps({
      color: "gray7",
      px: 2,
      fs: 1
    })(Div),
    HeaderStyler: defaultProps({
      display: "row.flex-start.center",
      pb: 2,
      bc: "neutral1",
      bb: 1
    })(Div),
    RowStyler: ({ openPreview, goToProfile, ...props }) => (
      <Div
        {...{
          display: "row.flex-start.center",
          bg: { default: "white", hover: "neutral0" },
          transition: "fast",
          py: 2,
          bra: 0,
          onClick:
            selectedOptions !== SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS
              ? openPreview || goToProfile
              : null,
          openPreview,
          goToProfile,
          ...props
        }}
      />
    ),
    TableStyler: defaultProps({
      mt: 0
    })(Div),
    rowCellComps: [
      ({ meta }) => (
        <Div fs={1} color="gray7" display="row.flex-start.center">
          {meta.name}
        </Div>
      ),
      ({ meta, goToProfile }) => (
        <Div
          fs={1}
          color="gray7"
          display="row.flex-start.center"
          style={{
            overflowWrap: "anywhere"
          }}
        >
          {goToProfile ? (
            <ErrorIcon
              color="red5"
              mr={
                mode === MODES.SMS
                  ? meta.phone && meta.phone.length
                    ? 1
                    : 0
                  : meta.email && meta.email.length
                  ? 1
                  : 0
              }
            />
          ) : null}
          {mode === MODES.SMS ? meta.phone : meta.email}
        </Div>
      ),

      ({ selected, openPreview, meta }) => (
        <Div>
          {openPreview &&
            selectedOptions !==
              SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS && (
              <Radio selected={selected} size={20} />
            )}
          {!openPreview && (
            <Div display="row.flex-start.center">
              <Div underline color="gray7" fs={1} mr={1}>
                Resolve
              </Div>
              <OpenInNewIcon size={13} />
            </Div>
          )}
          {openPreview &&
            selectedOptions ===
              SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS && (
              <>
                <Checkbox
                  checked={
                    R.find(
                      contact => contact?.id === meta?.id,
                      particularContactsSelected
                    )?.selected || false
                  }
                  onClick={() =>
                    handleSelectParticularContact({
                      id: meta?.id
                    })
                  }
                  disabled={refreshing}
                />
              </>
            )}
        </Div>
      )
    ]
  });
};

const Review = ({
  mode = MODES.EMAIL,
  loading = false,
  selectedOptions = SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS,
  handleSelectParticularContact = noop,
  setParticularContactsSelected = noop,
  particularContactsSelected = [],
  params = {},
  isLightEvent = false,
  isLightOrg = false,
  preview = {},
  multiplePreview = [],
  getPreview = noop,
  refreshing = false,
  refresh = noop,
  selectAll = noop,
  contactsSelected = [],
  countOfEmailSenders = 0,
  recipients = []
}) => {
  const [dropdownValue, setDropdownValue] = useState();
  const openPreview = (record, arrayOfContacts) => {
    getPreview({
      parentRecordId: R.path(["meta", "recordIds", 0])(record),
      childRecordId: R.path(["meta", "id"])(record),
      arrayOfContacts: arrayOfContacts
    });
  };

  const goToProfile = id => {
    if (params.eventId) {
      // open: event
      if (isLightEvent) {
        window.open(
          `${window.__LENND_APP_URL__}/event-light/${params.eventId}/contact/${id}`,
          "_blank"
        );
        return true;
      }
      window.open(
        `${window.__LENND_APP_URL__}/event/${params.eventId}/contact/${id}`,
        "_blank"
      );
    } else {
      // open: org
      if (isLightOrg) {
        window.open(
          `${window.__LENND_APP_URL__}/org-light/${params.orgId}/contact/${id}`,
          "_blank"
        );
        return true;
      }
      window.open(
        `${window.__LENND_APP_URL__}/organization/${params.orgId}/contact/${id}`,
        "_blank"
      );
    }
    return true;
  };

  const validFilter =
    mode === MODES.SMS
      ? r => R.pathOr(true, ["meta", "hasValidPhone"])(r)
      : r => R.pathOr(true, ["meta", "hasValidEmail"])(r);
  const invalidFilter =
    mode === MODES.SMS
      ? r => !R.pathOr(true, ["meta", "hasValidPhone"])(r)
      : r => !R.pathOr(true, ["meta", "hasValidEmail"])(r);

  const validRecipients = R.sortBy(
    receiptToSort => R.pathOr("", ["meta", "email"])(receiptToSort),
    recipients
  )
    .filter(validFilter)
    .map(r => ({
      ...r,
      selected: preview
        ? R.pathOr("", ["id"])(preview) === R.pathOr("", ["meta", "id"])(r)
        : false,
      openPreview: () =>
        openPreview(
          r,
          R.compose(
            R.map(c => ({
              parentRecordId: R.path(["meta", "recordIds", 0])(c),
              childRecordId: R.path(["meta", "id"])(c)
            })),
            R.filter(c => {
              const rEmail = R.pathOr("", ["meta", "email"])(r);
              const cEmail = R.pathOr("", ["meta", "email"])(c);
              return rEmail === cEmail;
            })
          )(recipients)
        )
    }));

  const groupByIdValidRecipients = [
    ...new Map(
      validRecipients?.map(item => [R.pathOr("", ["meta", "id"])(item), item])
    ).values()
  ];
  const invalidRecipients = recipients.filter(invalidFilter).map(r => ({
    ...r,
    goToProfile: () => goToProfile(r?.meta?.id)
  }));

  const countOfValidRecipients = groupByIdValidRecipients.length;
  const countOfInvalidRecipients = invalidRecipients.length;

  useEffect(() => {
    if (
      countOfValidRecipients > 0 &&
      selectedOptions === SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS
    ) {
      setParticularContactsSelected(
        formattedValidRecipients(groupByIdValidRecipients)
      );
      setDropdownValue(
        formattedValidRecipients(groupByIdValidRecipients)[0].id
      );
      openPreview(
        R.find(
          recipient =>
            R.pathOr({}, ["meta", "id"])(recipient) ===
            formattedValidRecipients(validRecipients)[0].id,
          validRecipients
        ),
        R.compose(
          R.map(c => ({
            parentRecordId: R.path(["meta", "recordIds", 0])(c),
            childRecordId: R.path(["meta", "id"])(c)
          })),
          R.filter(
            recipient =>
              R.pathOr({}, ["meta", "id"])(recipient) ===
              formattedValidRecipients(validRecipients)[0].id
          )
        )(validRecipients)
      );
    }
  }, []);

  useEffect(() => {
    const contactsSelected = R.filter(
      R.propEq("selected", true),
      particularContactsSelected
    );
    if (contactsSelected.length === 1) {
      setDropdownValue(contactsSelected[0].id);
      openPreview(
        R.find(
          recipient =>
            R.pathOr({}, ["meta", "id"])(recipient) === contactsSelected[0].id,
          validRecipients
        ),
        R.compose(
          R.map(c => ({
            parentRecordId: R.path(["meta", "recordIds", 0])(c),
            childRecordId: R.path(["meta", "id"])(c)
          })),
          R.filter(
            recipient =>
              R.pathOr({}, ["meta", "id"])(recipient) === contactsSelected[0].id
          )
        )(validRecipients)
      );
    }
  }, [particularContactsSelected]);

  const RecipientsTable = useMemo(
    () =>
      makeRecipientsTable(
        mode,
        selectedOptions,
        handleSelectParticularContact,
        particularContactsSelected,
        refreshing
      ),
    [
      mode,
      selectedOptions,
      handleSelectParticularContact,
      particularContactsSelected,
      refreshing
    ]
  );

  const messageDisplayText =
    countOfValidRecipients !== 1 ? "messages" : "message";
  const emailDisplayText = countOfEmailSenders !== 1 ? "emails" : "email";
  return (
    <Div display="row" height={1}>
      <Div
        width={410}
        height={1}
        br={1}
        p={5}
        bc="neutral0"
        style={{
          height: "100%",
          overflowY: "auto",
          minWidth: "350px"
        }}
      >
        <Div fs={4} fw={4} color="purple9" mb={5}>
          Review &amp; Preview
        </Div>

        {countOfValidRecipients ? (
          <Div mb={9}>
            {selectedOptions ===
            SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS ? (
              <Div display="row.flex-start.center" mb={5} color="gray7">
                {selectedOptions !==
                  SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS && (
                  <CheckCircleIcon color="green5" mr={1} />
                )}
                <Div fw={4} mr={1}>
                  {countOfEmailSenders}{" "}
                  {countOfEmailSenders !== 1 ? "people" : "person"}
                </Div>
                will receive{" "}
                {mode === MODES.SMS ? messageDisplayText : emailDisplayText}
              </Div>
            ) : (
              <Div display="row.flex-start.center" mb={5} color="gray7">
                {selectedOptions !==
                  SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS && (
                  <CheckCircleIcon color="green5" mr={1} />
                )}
                <Div fw={4} mr={1}>
                  {countOfValidRecipients}{" "}
                  {countOfValidRecipients !== 1 ? "people" : "person"}
                </Div>
                will receive{" "}
                {mode === MODES.SMS ? messageDisplayText : emailDisplayText}
              </Div>
            )}
            {selectedOptions ===
              SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS && (
              <Div
                display="row.flex-end.center"
                onClick={selectAll}
                mt={1}
                mb={1}
              >
                <Text1 color="primary9" underline>
                  Select All
                </Text1>
              </Div>
            )}
            <RecipientsTable rowsData={groupByIdValidRecipients} />
          </Div>
        ) : null}

        {countOfInvalidRecipients ? (
          <Div mb={9}>
            <Div display="row.flex-start.center" mb={5} color="gray7">
              <ErrorIcon color="red5" mr={1} />
              <Div fw={4} mr={1}>
                {countOfInvalidRecipients}{" "}
                {countOfInvalidRecipients !== 1 ? "people" : "person"}
              </Div>
              {countOfInvalidRecipients !== 1 ? "have" : "has"}{" "}
              {mode === MODES.SMS ? "phone number" : "email"} issues to resolve
            </Div>
            <RecipientsTable rowsData={invalidRecipients} />
          </Div>
        ) : null}

        {countOfInvalidRecipients ? (
          <Div display="column.center.center" width={1}>
            <Div color="gray6" mb={2}>
              Resolved the {mode === MODES.SMS ? "phone number" : "email"}{" "}
              issues?
            </Div>
            <Div
              display="row.center.center"
              width={1}
              bra={1}
              p={3}
              bg={{
                default: "neutral0",
                hover: "neutral1"
              }}
              onClick={refreshing ? undefined : refresh}
            >
              {refreshing ? (
                <LoadingIcon size={20} color="gray5" mr={2} />
              ) : (
                <RefreshIcon size={20} color="gray5" mr={2} />
              )}
              <Div fw={3} fs={3} color="gray5">
                {refreshing ? "Reloading" : "Reload this step"}
              </Div>
            </Div>
          </Div>
        ) : null}
        {!countOfValidRecipients && !countOfInvalidRecipients ? (
          <Div display="row.flex-start.center" mb={5} color="gray7">
            <ErrorIcon color="red5" mr={1} />
            There are no recipients that match your criteria.
          </Div>
        ) : null}
      </Div>
      <Div flex={1} bg="white">
        {loading ? (
          <Loading />
        ) : (preview && preview.id) ||
          selectedOptions ===
            SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS ? (
          <>
            <Div
              display="column"
              bg="white"
              p={5}
              height={mode === MODES.EMAIL ? 80 : undefined}
              bb={1}
              bc="neutral0"
            >
              <Div display="row.flex-start.center" mb={1}>
                <Div mr={1} color="gray5">
                  Preview As:
                </Div>
                {selectedOptions !==
                SEND_TO_OPTION_TYPES.SELECT_INDIVIDUAL_CONTACTS ? (
                  <Div fw={3} color="gray7">
                    {preview.name}{" "}
                    {mode === MODES.EMAIL
                      ? `<${preview.email}>`
                      : ` - ${preview.phone}`}
                  </Div>
                ) : (
                  <Dropdown
                    onChange={({ value }) => {
                      setDropdownValue(value);
                      openPreview(
                        R.find(
                          recipient => recipient?.meta.id === value,
                          validRecipients
                        ),
                        R.compose(
                          R.map(c => ({
                            parentRecordId: R.path(["meta", "recordIds", 0])(c),
                            childRecordId: R.path(["meta", "id"])(c)
                          })),
                          R.filter(recipient => recipient?.meta.id === value)
                        )(validRecipients)
                      );
                    }}
                    selected={dropdownValue}
                    options={contactsSelected}
                    width="80%"
                  />
                )}
              </Div>

              {mode === MODES.EMAIL && preview ? (
                <Div display="row.flex-start.center">
                  <Div mr={1} color="gray5">
                    Subject:
                  </Div>
                  <Div fw={3} color="gray7">
                    {preview.subject}
                  </Div>
                </Div>
              ) : null}
            </Div>

            <Div
              p={5}
              style={{
                height: "100%",
                overflowY: "auto"
              }}
            >
              <Div bra={1} bg="white" shadow={1}>
                {preview ? (
                  mode === MODES.SMS ? (
                    <span
                      style={{
                        whiteSpace: "pre-line",
                        display: "block",
                        padding: "10px"
                      }}
                      dangerouslySetInnerHTML={{
                        __html: preview.content
                      }}
                    />
                  ) : (
                    <IFrame
                      style={{
                        width: "100%",
                        border: 0,
                        height: "750px",
                        marginBottom: "30px"
                      }}
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: preview.content
                        }}
                      />
                    </IFrame>
                  )
                ) : null}
                {multiplePreview && multiplePreview.length > 0 ? (
                  <>
                    {R.map(
                      p => (
                        <>
                          {p.content ? (
                            <IFrame
                              style={{
                                width: "100%",
                                border: 0,
                                height: "750px",
                                marginBottom: "30px"
                              }}
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: p.content
                                }}
                              />
                            </IFrame>
                          ) : null}
                        </>
                      ),
                      multiplePreview
                    )}
                  </>
                ) : null}
              </Div>
            </Div>
          </>
        ) : (
          <Div
            display="flex.center.center"
            fs={5}
            fw={2}
            color="gray7"
            width={1}
            height={1}
          >
            Select a recipient from the left sidebar to preview
          </Div>
        )}
      </Div>
    </Div>
  );
};

export default decorate(Review);
